import { ReduxAction } from '../../types/common'
import { GET_PERSONS } from '../actionTypes'
import { Person } from './clients'

interface PersonState {
  persons: Person[]
}

const INITIAL_STATE = {
  persons: [],
}

export const persons = (state: PersonState = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case GET_PERSONS:
      return {
        ...state,
        persons: action.payload as Person[],
      }
    default:
      return state
  }
}
